<template>
  <div class="animated fadeIn">
    <component-header
      title="Advertisements"
      @search-query="(val) => (filter = val)"
      :isLoading="loading"
      @reload-data="getAdvertisementList"
      :hasback="true"
      @back-press="goToViewPage"
      @create-press="$router.push({ path: '/advertisement/create' })"
    />
    <loader v-if="loading"></loader>
    <b-card class="card-wrap" border-variant="info">
      <div>
        <b-table
          class="tableRadius"
          responsive
          :fields="adsColumns"
          :items="ads"
          :dark="dark"
          :filter="filter"
          :hover="hover"
          thead-class="header"
          :striped="striped"
          :bordered="bordered"
          :current-page="currentPage"
          :per-page="perPage"
          :small="small"
          show-empty
          :fixed="fixed"
          ref="ads"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
        >
          <template slot="active" slot-scope="data">
            <div class="table-row">
              <c-switch
                @change="(e) => switchBannerStatus(data.item, e)"
                class="mx-1"
                color="primary"
                v-model="data.item.active"
                label
                variant="pill"
                data-on="yes"
                data-off="yes"
              />
            </div>
          </template>
          <template slot="icon" slot-scope="data">
            <div class="table-row">
              <!-- {{data.item.icon}} -->
              <img
                style="height: 80px; width: 80px; text-align: center"
                :src="data.item.icon"
              />
            </div>
          </template>
          <template slot="visibility" slot-scope="data">
            <div class="table-row">
              {{
                data &&
                data.item &&
                data.item.target &&
                data.item.target.visibility &&
                data.item.target.visibility.type
              }}
            </div>
          </template>
          <template slot="action" slot-scope="data">
            <div class="inline_btnTable">
              <b-button
                size="sm"
                class="mr-2 butto-circle"
                variant="primary"
                @click="viewAd(data.item)"
              >
                <i class="fa fa-eye"></i>
              </b-button>
              <b-button
                size="sm"
                class="mr-2 butto-circle"
                variant="primary"
                @click="editAd(data.item)"
              >
                <i class="fas fa-pencil-alt edit"></i>
              </b-button>
              <b-button
                size="sm"
                class="mr-2 butto-circle"
                variant="danger"
                @click="deleteAd(data.item)"
              >
                <i class="fas fa-trash-alt edit"></i>
              </b-button>
            </div>
          </template>
        </b-table>
      </div>
      <div style="float: right">
        <b-pagination
          v-model="currentPage"
          :per-page="perPage"
          :total-rows="ads.length"
          aria-controls="my-table"
          prev-text="Prev"
          next-text="Next"
          hide-goto-end-buttons
        ></b-pagination>
      </div>
    </b-card>
  </div>
</template>
<script>
import ebButton from "@/components/FormElements/Button";
import ComponentHeader from "@/components/componentHeader";
import { Switch as cSwitch } from "@coreui/vue";
import loader from "@/components/loader/nipigeloader.vue";
import { mapGetters } from "vuex";

export default {
  name: "Advertisement",
  components: {
    ebButton,
    cSwitch,
    loader,
    ComponentHeader,
  },
  data() {
    return {
      partner: {},
      loading: false,
      currentPage: 1,
      filter: "",
      perPage: 5,
      hover: true,
      striped: false,
      bordered: true,
      small: false,
      fixed: false,
      dark: false,
      sortBy: "createdAt",
      sortDesc: true,
      adsColumns: [
        {
          key: "icon",
        },
        {
          key: "type",
        },
        {
          key: "placement",
        },
        {
          key: "visibility",
        },
        // {
        //   key: "tags",
        // },
        {
          key: "active",
        },
        {
          key: "action",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      AdList: "advertisement/GetAdList",
      userId: "auth/getUserID",
    }),
    ads() {
      const addata = this.AdList;
      let data = [];
      if (Array.isArray(addata) && addata.length > 0) {
        data = addata.map((obj) => ({
          ...obj,
          // visibility: obj.target.visibility.type,
          locationRadius: obj.target.locationRadius,
          // tags: obj.tag.length,
          icon: obj.icon.fileUrl,
        }));
        return data;
      } else if (Array.isArray(addata) && addata.length === 0) {
        return [];
      } else {
        let dataArr = [addata];
        dataArr = dataArr.map((obj) => ({
          ...obj,
          // visibility: obj.target.visibility.type,
          locationRadius: obj.target.locationRadius,
          // tags: obj.tag.length,
          icon: obj.icon.fileUrl,
        }));
        return dataArr;
      }
    },
  },
  methods: {
    async switchBannerStatus(data, value) {
      let payload = {
        id: data._id,
        switchvalue: { status: value },
      };
      await this.$store.dispatch("advertisement/toSwitchBannerStatus", payload)
    },
    viewAd(data) {
      this.$store.dispatch("advertisement/setAdobject", data);
      this.$router.push({
        name: "View Ad",
        params: {
          id: data._id,
        },
      });
    },
    editAd(data) {
      this.$store.dispatch("advertisement/setAdobject", data);
      this.$router.push({
        name: "Edit Ad",
        params: {
          id: data._id,
        },
      });
    },
    deleteAd(data) {
      this.$swal({
        title: "Delete this Ad?",
        text: "Are you sure? You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("advertisement/deleteAd", data._id)
            .then(() => {
              this.$toasted.success("Ad Deleted!");
              this.getAdvertisementList()
            })
            .catch((err) => {
              this.$toasted.error("Ad not deleted");
            });
        }
      });
    },
    goToViewPage() {
      if (this.$route.fullPath == "/advertisement") {
        this.$router.push({
          name: "Home",
        });
      } else {
        this.$router.push({
          name: "PartnerView",
          params: {
            id: this.$route.params.id,
            parentId: this.$route.params.parentId,
          },
        });
      }
    },
    async getAdvertisementList() {
      this.loading = true;
      let payload =
        this.$currentUserData.category === "SELLER"
          ? {
              provider: this.$currentUserData._id,
              all: true,
            }
          : {
              all: true,
            };
      await this.$store
        .dispatch("advertisement/fetchAdListforTenant", payload)
        .then((data) => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
  async mounted() {
    this.getAdvertisementList();
    this.loading = true;
    if (this.$store.getters["catalog/GetCategoryList"].length == 0) {
      await this.$store.dispatch("catalog/fetchCatalogList", "");
    }
    this.loading = false;
  },
};
</script>

<style lang="sass" scoped>
.edit
  color: white !important
.text-center
  text-align: center
.form-div label
  margin-top: 8px
</style>
